import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { bool, shapeOf, string } from 'prop-types';
import { trackVideoCompleted, trackVideoPlay } from './analytics';
import track, { TrackingPropType } from 'react-tracking';
import { withAnalytics, safeBuildEventObj } from '@ynap/analytics';
import { withMessages } from '@ynap/immutables-provider';

const bem = new BEMHelper('HtmlVideoPlayer');
@track()
class HtmlVideoPlayer extends PureComponent {
    constructor(props) {
        super(props);

        this.seekbarProgress = React.createRef();
        this.seekbarBuffered = React.createRef();

        this.state = {
            paused: true,
            trackPlayed: false,
            trackCompleted: false,
        };

        this.handleClick = this.handleClick.bind(this);
        this.updateProgressBar = this.updateProgressBar.bind(this);
        this.onPlay = this.onPlay.bind(this);
        this.safeTrackEvent = this.safeTrackEvent.bind(this);
    }

    safeTrackEvent(buildAnalyticsFunc, ...args) {
        const { analytics, tracking } = this.props;
        tracking.trackEvent(safeBuildEventObj(buildAnalyticsFunc, analytics, ...args));
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.intersected && this.props.intersected) {
            let playPromise = this.video.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        // Autoplay started!
                    })
                    .catch(() => {
                        // Auto-play was prevented
                    });
            }
        } else if (prevProps.intersected && !this.props.intersected) {
            this.video.pause();
        }
        this.setState({
            paused: this.video.paused,
        });
    }

    onPlay() {
        const { video } = this.props;
        const { trackPlayed } = this.state;

        if (!trackPlayed) {
            this.safeTrackEvent(trackVideoPlay, video);
            this.setState({ trackPlayed: true });
        }
    }

    handleClick(e) {
        const video = e.target;
        video.paused ? video.play() : video.pause();
        this.setState({
            paused: video.paused,
        });
    }

    updateProgressBar(e) {
        const videoComponent = e.target;
        const { video } = this.props;
        const { trackCompleted } = this.state;
        var value = ((videoComponent.currentTime / videoComponent.duration) * 100).toFixed(2);
        this.seekbarProgress.current.style.width = value + '%';

        var percentageBuffered = ((videoComponent.buffered.end(0) - videoComponent.buffered.start(0)) / videoComponent.duration) * 100;
        this.seekbarBuffered.current.style.width = percentageBuffered + '%';

        if (value > 95 && !trackCompleted) {
            this.safeTrackEvent(trackVideoCompleted, video);
            this.setState({
                trackCompleted: true,
            });
        }
    }

    render() {
        const { video, messages, className } = this.props;
        const { paused } = this.state;
        const playPause = messages?.video?.playPause();

        return (
            <div className={bem('wrapper')}>
                <button className={bem('playButtonIcon', paused ? 'iconPlay' : 'iconPause', 'playButtonIcon')} aria-label={playPause} />

                <video
                    ref={(node) => (this.video = node)}
                    className={bem('video', null, className)}
                    onClick={this.handleClick}
                    poster={video.thumbnail?.url}
                    muted
                    loop
                    onPlay={this.onPlay}
                    onTimeUpdate={this.updateProgressBar}
                    playsInline
                    preload="none"
                >
                    <source src={video.url} type="video/mp4" />
                </video>

                <div className={bem('video-controls')}>
                    <input type="range" className={bem('seekbar', 'seekbarFull')} />
                    <div className={bem('seekbar', 'seekbarProgress')} ref={this.seekbarProgress} />
                    <div className={bem('seekbar', 'seekbarBuffered')} ref={this.seekbarBuffered} />
                </div>
            </div>
        );
    }
}

HtmlVideoPlayer.propTypes = {
    video: shapeOf({
        thumbnail: shapeOf({
            url: string,
        }),
        url: string.isRequired,
    }),
    intersected: bool,
    analytics: shapeOf({
        category: shapeOf({
            pageType: string.isRequired,
            subCategory1: string.isRequired,
        }),
    }),
    tracking: TrackingPropType,
};
export { HtmlVideoPlayer };
export default withMessages()(withAnalytics(HtmlVideoPlayer));
